import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon, NewButton } from '../../../../../components';

const AssetViewTabsContainer = styled.nav`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
`;

const AssetViewTabs = ({
  onViewChange,
  handleCollapseAsset = null,
  showChartTab = true,
  showSourceTab = true,
  activeView = 'table',
  chartTitle = null
}) => (
  <AssetViewTabsContainer>
    {handleCollapseAsset && activeView !== 'chart' && (
      <NewButton secondary onClick={() => handleCollapseAsset()}>
        <Icon name='double-chevron-right' displaySize={20} />
      </NewButton>
    )}
    <NewButton tertiary active={activeView === 'table'} onClick={() => onViewChange('table')}>
      <Icon size={24} displaySize={20} name='table' />
      Table
    </NewButton>
    {showSourceTab && (
      <NewButton tertiary active={activeView === 'source'} onClick={() => onViewChange('source')}>
        <Icon size={20} name='cylinder' />
        Source
      </NewButton>
    )}
    {showChartTab && (
      <NewButton tertiary active={activeView === 'chart'} onClick={() => onViewChange('chart')}>
        <Icon size={20} name={chartTitle ? 'chart' : 'plus'} />
        {chartTitle || 'Add chart'}
      </NewButton>
    )}
  </AssetViewTabsContainer>
);

AssetViewTabs.propTypes = {
  activeView: PropTypes.string,
  chartTitle: PropTypes.string,
  onViewChange: PropTypes.func.isRequired,
  showChartTab: PropTypes.bool,
  showSourceTab: PropTypes.bool,
  handleCollapseAsset: PropTypes.func
};

export { AssetViewTabs };
